import { categoryIconAndRoute } from '~/constants/categoryIconAndRoute';
import { TimesplitId } from '~/types/TimesplitId';

export default function TimesplitAndPattern({
  timesplitId,
  templateName,
}: {
  timesplitId: TimesplitId;
  templateName: string;
}) {
  // a custom pattern belongs to no timesplit category, so there is no pie icon for it
  const icon = categoryIconAndRoute[timesplitId as TimesplitId]?.icon;

  return (
    <div className="flex items-center justify-start px-4 pt-4">
      <div className="flex items-center justify-start">
        {icon}
        <span className={`text-green-primary-text text-lg font-medium ${icon ? 'pl-2' : ''}`}>{templateName}</span>
      </div>
    </div>
  );
}
